import React from "react";
import {List, Avatar, Button, Skeleton, Popover, Input, Col, Row, Select, Card, Radio, PageHeader} from 'antd';
import moment from "moment";
import Connector from "../../../redux/connector";
import Page from "../../../layout/web/Page";
import PlusOutlined from "@ant-design/icons/es/icons/PlusOutlined";

import {AudioOutlined} from '@ant-design/icons';
import {GetUserToken} from "../../../api/token";
import {fetchDataEntity} from "../../../api/entity-data";
import {
    findRecordKey2, findRecordKeyField2,
    findRecordType, GetListField,
    GetRecordDisplayName,
    LoadDataAnyEndpoint,
    SortData,
 SubmitLogInformation,

} from "../../../api/fn";

import {SearchOutlined} from '@ant-design/icons';

import DrawerNewEntry from "../../../components/General/DrawerNewEntry2";
import NewActivityDrawer from "../../../components/Common/workboard/NewActivityDrawer";
import NewStatusDrawer from "../../../components/Common/workboard/NewStatusDrawer";
import NewPriorityDrawer from "../../../components/Common/workboard/NewPriorityDrawer";
import MoreDetailDrawer from "../../../components/Common/workboard/MoreDetailDrawer";
import NewStageDrawer from "../../../components/Common/workboard/NewStageDrawer";
import NewCommentDrawer from "../../../components/Common/workboard/NewCommentDrawer";
import NewReminderDrawer from "../../../components/Common/workboard/NewReminderDrawer";


const {Option} = Select;
const {Search} = Input;
const suffix = (
    <AudioOutlined
        style={{
            fontSize: 16,
            color: '#1890ff',
        }}
    />
);
const count = 3;
const fakeDataUrl = `https://randomuser.me/api/?results=${count}&inc=name,gender,email,nat&noinfo`;

class WorkboardActionPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Companies: [],
            Projects: [],
            Attributes: [],
            Databases: [],
            Files: [],
            Fields: [],
            selectedCompany: "",
            selectedProject: "",
            initLoading: false,
            loading: false,
            data: [],
            list: [],
            showActions: {},
            searchText: "",
            showNewCase: true,
            newEntry: {},
            Users: [],
            UserVoips: [],
            UserProjects: [],
            Comments: [],

            totalEscalated: 0,
            totalNewCase: 0,
            totalOutbound: 0,
            totalInbound: 0,
            totalStatus: "Online",

            ActionData: null,
            showActionActivity: false,
            showActionStage: false,
            showActionActionStatus: false,
            showActionPriority: false,
            showMoreDetail: false,
            showActionComment: false,
            showActionReminder:false,
            moreDetailData: null,

            Activities: [],
            Statuses: [],
            Stages: [],
            Priorities: [],
            Informations: [],
            filters: {},
            filtersAdditions: {},
            typeFilter: "options"
        };

        this.arrayholder = [];
    }

    componentDidMount = async () => {

        await this.initialReload();
        await this.loadDatabase();
        /*await this.getData((data) => {
            console.log("get data loaded 100% > ", data)
        })*/
    }
    initialReload = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this);
        await fetchDataEntity("Projects", "", "", this, undefined, "common/entity/modules/list");
        await fetchDataEntity("Attributes", "", "", this, undefined, "common/entity/attributes/list");
        await fetchDataEntity("Fields", "", "", this, undefined, "common/entity/Fields/list");
        await fetchDataEntity("Files", "", "", this, undefined, "common/entity/files/list");
        await fetchDataEntity("UserVoips", "", "", this, undefined, "common/entity/AllocationUserViop/list");
        await fetchDataEntity("UserProjects", "", "", this, undefined, "common/entity/AllocationUserProject/list");
        await fetchDataEntity("Databases", "", "", this, undefined, "common/entity/databases/list");
        await fetchDataEntity("Activities", "", "", this, undefined, "common/entity/Activities/list");
        await fetchDataEntity("Stages", "", "", this, undefined, "common/entity/Stages/list");
        await fetchDataEntity("Statuses", "", "", this, undefined, "common/entity/Statuses/list");
        await fetchDataEntity("Priorities", "", "", this, undefined, "common/entity/Priorities/list");
        await fetchDataEntity("Informations", "", "", this, undefined, "common/entity/Informations/list");
        await fetchDataEntity("Comments", "", "", this, undefined, "common/entity/Comments/list");
        await this.loadUsers();
    }
    loadUsers = async () => {
        let userInfo = GetUserToken();
        let hub = {};
        // hub.Org = userInfo.Org;
        let endpoint = "/user/list";
        await LoadDataAnyEndpoint(hub, endpoint, "Users", this, (data) => {
            console.log("loadUsers > ", data)
        });

    }
    findUserName = (username) => {
        for (let i in this.state.Users) {
            let row = this.state.Users[i];
            if (row.Username === username) {
                return row.FullName;
            }
        }
        return username;
    }
    requestMoreDetailView = (item) => {
        this.setState({
            showMoreDetail: true,
            moreDetailData: item,
        })
    }
    getLastAction = (org, project, ref) => {
        let arrData = this.state.Informations;
        arrData = SortData("orgdatetime", arrData);
        let status = '', priority = '', stage = '', statusColor = '', priorityColor = '', activity = '';
        for (let i in arrData) {
            let row = arrData[i];
            if (row.org !== org) {
                continue
            }
            if (row.project !== project) {
                continue
            }
            if (row.ref !== ref) {
                continue
            }

            if (row.action === "status") {
                status = row.name;
                statusColor = row.data.color;
            }

            if (row.action === "priority") {
                priority = row.name;
                priorityColor = row.data.color;
            }

            if (row.action === "stage") {
                stage = row.name;
            }
            if (row.action === "activity") {
                activity = row.name;
            }

        }

        return {status, statusColor, priority, priorityColor, stage, activity}

    }
    loadDatabase = async () => {

        let _this = this;
        let userInfo = GetUserToken();
        let info = this.getInfo();
        let {project} = info;
        let org = userInfo.Org;

        console.log("> F3 ", org, " > ", info);

        let ls = [];
        let defautlUrl = "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png";
        for (let i in this.state.Databases) {
            let row = this.state.Databases[i];
            if (row.org !== org) {
                continue
            }
            if (row.module !== project) {
                continue
            }
            let name = GetRecordDisplayName(org, project, row, this.state.Attributes, "displayselection");
            let ref = row.ref;
            //let status=this.findStatus(row),stage=this.findStage(row),priority=this.findPriority(row);
            let {stage, priorityColor, priority, statusColor, status, activity} = this.getLastAction(org, project, ref);
            let description = (<div> Status: <span style={{color: statusColor}}> {status}</span>
                ; Priority: <span style={{color: priorityColor}}>{priority}</span> ; Stage: {stage} ;
                Activity: {activity}</div>);
            ls.push({
                name: name + " (" + ref + ")",
                record: row,
                description: description,
                url: defautlUrl,
                lastUpdate: row.orgdatetime,
                lastStatus: status,
                lastActivity: activity,
                lastPriority: priority,
                lastStage: stage
            })
        }

        _this.arrayholder = ls;
        _this.setState({
            list: ls
        });

        /*await LoadDataNoCondition("databases","list",_this,params,(data)=>{
            data = SortDataDesc("orgdatetime",data);
            _this.arrayholder = data;
            _this.setState({
                list: data
            });
        });*/
    }
    getData = async () => {


    };

    onChangeTypeFilter = (keyIn) => {
        let val = keyIn.target.value;
        console.log("onChangeTypeFilter > ", val)
        this.setState({
            typeFilter: val
        })
    }
    handleChange = async (e, key) => {
        const value = e.value;
        console.log("handleChange --> ", key, " > ", value);
        this.setState({
            [key]: value,
        })

        if (key === "selectedModule" && this.state.Org !== "") {
            await this.fetchDataByFilter()
        }

    }
    handleChange2 = async (e, key) => {
        const value = e;
        console.log("2 handleChange --> ", key, " > ", value);
        this.setState({
            [key]: value,
        })

    }
    handleChangeInput = (key, val) => {
        let tmp = this.state;
        tmp.newEntry[key] = val;
        this.setState(tmp);
        console.log("handleChangeInput > ", key, " > ", val);
    }

    handleChangeInput2 = (key, e) => {
        let val = e.target.value;
        let tmp = this.state;
        tmp.newEntry[key] = val;
        this.setState(tmp);
        console.log("handleChangeInput2 > ", key, " > ", val);
    }

    openNewCaseDrawer = () => {
        this.setState({
            showNewCase: true,
        })
    }
    closeNewCaseDrawer = () => {
        this.setState({
            showNewCase: false,
        })
    }

    onClickBtnFilterSearch = async () => {
        await this.loadDatabase();
        let _this = this;
        let ls = this.arrayholder;
        console.log("ls (:)--> ", ls)
        let newData = ls.filter(item => {
            let data = item.record.data;
            console.log("filters (:)--> ", _this.state.filters)
            console.log("item (:)--> ", item);
            for (let i in _this.state.filters) {
                let key = i;
                let val = _this.state.filters[key];
                if (typeof data[key] === "undefined") {
                    return null
                }
                if (data[key] !== val) {
                    return null
                }
            }
            return item;
        });
        this.setState({
            list: newData,
            searchText: "",
        })
    }
    onClickBtnFilterAdditionalSearch = async () => {
        await this.loadDatabase();
        let _this = this;
        let ls = this.arrayholder;
        //console.log("_this.state.filtersAdditions (:)--> ", _this.state.filtersAdditions)
        let newData = ls.filter(item => {
            for (let i in _this.state.filtersAdditions) {
                let key = i;
                let val = _this.state.filtersAdditions[key];
                console.log("_this.state.filtersAdditions (:)--> status > ", key," > ",val)
                if (key === "status") {
                    if (item["lastStatus"] !== val) {
                        return null
                    }
                }
                if (key === "stages") {
                    if (item["lastStage"] !== val) {
                        return null
                    }
                }
                if (key === "priorities") {
                    if (item["lastPriority"] !== val) {
                        return null
                    }
                }
                if (key === "activities") {
                    if (item["lastActivity"] !== val) {
                        return null
                    }
                }
            }
            return item;
        });
        this.setState({
            list: newData,
            searchText: "",
        })
    }
    onLoadMore = async () => {

        await this.loadDatabase();
        window.dispatchEvent(new Event('resize'));
        return
        this.setState({
            loading: true,
            list: this.state.data.concat([...new Array(count)].map(() => ({loading: true, name: {}}))),
        });
        this.getData(res => {
            const data = this.state.data.concat(res.results);
            this.setState(
                {
                    data,
                    list: data,
                    loading: false,
                },
                () => {
                    // Resetting window's offsetTop so as to display react-virtualized demo underfloor.
                    // In real scene, you can using public method of react-virtualized:
                    // https://stackoverflow.com/questions/46700726/how-to-use-public-method-updateposition-of-react-virtualized
                    window.dispatchEvent(new Event('resize'));
                },
            );
        });
    };

    onSearch = async (textInput) => {
        await this.loadDatabase();
        console.log("onSearch > ", textInput)
        let ls = this.arrayholder;
        let newData = ls.filter(item => {
            const itemData = JSON.stringify(item).toLocaleLowerCase();
            const textData = textInput.toLocaleLowerCase();
            return itemData.indexOf(textData) > -1
        });
        this.setState({
            list: newData,
            searchText: textInput,
        })
    }
    onChangeSearch = (inputObject) => {
        /*const text = inputObject.target.value;
        let ls = [];
        ls = this.arrayholder;
        let newData = ls.filter(item => {
            const itemData = JSON.stringify(item).toLocaleLowerCase();
            const textData = text.toLocaleLowerCase();
            return itemData.indexOf(textData) > -1
        });
        this.setState({
            list: newData,
            searchText: text,
        })*/
    }
    closeDrawer = () => {
        this.setState({
            showNewCase: false,
        })
    }
    closeNewCaseDrawer = () => {
        this.setState({
            showNewCase: true,
        })
    }
    getDatabaseAttributes = () => {
        let _this = this;
        let userInfo = GetUserToken();
        let {project} = this.getInfo();
        let org = userInfo.Org;

        let ls = [];
        let defautlUrl = "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png";
        for (let i in this.state.Attributes) {
            let row = this.state.Attributes[i];
            if (row.org !== org) {
                continue
            }
            if (row.module !== project) {
                continue
            }
            let name = GetRecordDisplayName(org, project, row, this.state.Attributes, "displayselection")
            ls.push(row)
        }
        ls = SortData("position", ls);
        return ls

    }
    getHandleChangeValKey = (key) => {
        if (typeof this.state.newEntry[key] === "undefined") {
            return ""
        }
        return this.state.newEntry[key];
    }

    getAttributes = () => {
        let _this = this;
        let userInfo = GetUserToken();
        let {project} = this.getInfo();
        let org = userInfo.Org;

        let ls = [];
        for (let i in this.state.Attributes) {
            let row = this.state.Attributes[i];
            if (row.org !== org) {
                continue
            }
            if (row.module !== project) {
                continue
            }
            ls.push(row)
        }
        ls = SortData("position", ls);
        return ls

    }
    getDefaultDataList = () => {
        let status = "Open";
        let priority = "1";
        let stage = "Level 1";
        let defautlUrl = "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png";
        return [
            {
                name: "MErveilleux biangacila 1",
                description: "Status: " + status + "; Priority: " + priority + "; Stage: " + stage,
                url: defautlUrl
            },
            {
                name: "MErveilleux biangacila 2",
                description: "Status: " + status + "; Priority: " + priority + "; Stage: " + stage,
                url: defautlUrl
            },
            {
                name: "MErveilleux biangacila 3",
                description: "Status: " + status + "; Priority: " + priority + "; Stage: " + stage,
                url: defautlUrl
            },
            {
                name: "MErveilleux biangacila 4",
                description: "Status: " + status + "; Priority: " + priority + "; Stage: " + stage,
                url: defautlUrl
            },
            {
                name: "MErveilleux biangacila 5",
                description: "Status: " + status + "; Priority: " + priority + "; Stage: " + stage,
                url: defautlUrl
            },
        ]
    }
    validateSubmitINput = () => {
        let attributes = this.getDatabaseAttributes();
        let newEntry = this.state.newEntry;
        for (let i in attributes) {
            const row = attributes[i];
            console.log("validateSubmitINput > ", newEntry[row.fieldname], row.fieldname, attributes);
            console.log("validateSubmitINput 2  > ", newEntry);
            if (row.mandatory) {
                if (typeof newEntry[row.fieldname] === "undefined") {
                    alert("Sorry " + row.fieldname + " is required field and can't be empty!");
                    return false;
                }
                if (newEntry[row.fieldname] === "") {
                    alert("Sorry " + row.fieldname + " is required field and can't be empty!");
                    return false;
                }
            }
        }
        return true;
    }

    onSubmitRecord = async () => {
        if (!this.validateSubmitINput()) {
            return
        }
        let _this = this;

        if (!window.confirm("Are you sure to submit this record!")) {
            return
        }
        let {project, org} = this.getInfo();


        let fieldsList = GetListField(org, project, this.state.Attributes, this.state.Databases);
        let fieldsListOriginal = this.getAttributes();
        console.log(":::::)-> Org: ", org, " > ", project, " > ", fieldsList);
        /*let ls = [];
        for (let i in this.state.Attributes) {
            const row = this.state.Attributes[i];
            if (row.org !== org) {
                continue
            }
            if (row.module !== project) {
                continue
            }
            fieldsListOriginal.push(row);
        }*/

        let o = {};
        for (let i in fieldsList) {
            const row = fieldsList[i];
            const key = row.field;
            let val = this.state.newEntry[key];
            const type = findRecordType(key, fieldsList);
            if (type === "float") {
                val = parseFloat(val)
            } else if (type === "number") {
                val = parseInt(val)
            } else if (type === "boolean") {
                val = val === "yes"
            } else {
                //todo do nothing
            }
            o[key] = val;
        }


        let inData = {data: o}
        let names = GetRecordDisplayName(org, project, inData, this.state.Attributes, "displaydelection");
        console.log("onSubmitRecord send 1 > ", o, " > ", this.state.newEntry);
        let uniqueKeyField = findRecordKeyField2(fieldsListOriginal, "unique");
        let uniqueValue = "";
        if (typeof o[uniqueKeyField] !== "undefined") {
            uniqueValue = o[uniqueKeyField];
        }
        let hub = {
            Org: org,
            module: project,
            Data: o,
            Ref: uniqueValue,
            names: names,
            Email: findRecordKey2(fieldsListOriginal, "email", o),
            Phone: findRecordKey2(fieldsListOriginal, "phone", o),
            Username: findRecordKey2(fieldsListOriginal, "username", o),
            Name: findRecordKey2(fieldsListOriginal, "name", _this),
            Surname: findRecordKey2(fieldsListOriginal, "surname", o),
            Password: findRecordKey2(fieldsListOriginal, "password", o),
            UniqueKey: uniqueKeyField
        }


        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = hub;
        post.Params = {}
        let endpoint = "/common/entity/databases/insert"; // "/manager/entity/insert/extensions";

        console.log("onSubmitRecord send 2 > ", post);

        await LoadDataAnyEndpoint(post, endpoint, "Data", this, async (data) => {
            console.log("onSubmitRecord response > ", data);
            await fetchDataEntity("Databases", "", "", _this, undefined, "common/entity/databases/list");
            await _this.loadDatabase();
            _this.closeDrawer();
            _this.setState({
                newEntry: {},
            });
            await SubmitLogInformation(org, project, "new case", "all", "all", uniqueValue, o, _this)
            alert("Thank you record added!")
            window.location.reload();
        });


    }
    requestNewActionOpen = (row) => {
        let tmp = this.state;
        tmp.showActions = {};
        tmp.showActions[row.name] = true;
        tmp.ActionData = row;
        this.setState(tmp);
    }
    requestNewActionClose = (row) => {
        let tmp = this.state;
        tmp.showActions = {};
        this.setState(tmp)
    }
    requestNewActionHandleVisibleChange = (row, visible) => {
        let tmp = this.state;
        tmp.showActions[row.name] = visible;
        this.setState(tmp);
    };

    getVisibility = (row) => {
        let boo = false;
        if (typeof this.state.showActions[row.name] !== "undefined") {
            boo = this.state.showActions[row.name];
        }
        return boo;
    }
    getSelectedPopoverTitle = () => {
        let name = "none";
        for (let i in this.state.showActions) {
            name = i;
        }
        return name;
    }
    getInfo = () => {
        let userInfo = GetUserToken();
        let extension = "", project = "", name = userInfo.FullName, email = userInfo.Username, phone = userInfo.Phone,
            org = userInfo.Org;
        for (let i in this.state.UserProjects) {
            let row = this.state.UserProjects[i];
            if (row.user === userInfo.Username) {
                project = row.project;
            }
        }
        for (let i in this.state.UserVoips) {
            let row = this.state.UserVoips[i];
            if (row.user === userInfo.Username) {
                extension = row.extension;
            }
        }

        return {extension, project, name, email, phone, org}

    }
    renderCompaniesComboxbox = () => {
        let user = GetUserToken();
        let ls = [];
        for (let i in this.state.Companies) {
            const row = this.state.Companies[i];
            if (user.Role === "super") {
                ls.push({
                    key: row.CustomerNumber,
                    val: row.Name,
                })
            } else {
                if (row.CustomerNumber === user.Org) {
                    ls.push({
                        key: row.CustomerNumber,
                        val: row.Name,
                    })
                }
            }


        }
        return (
            <Select
                name={"Org"}
                defaultValue=""
                onChange={(e, ee) => this.handleChange(ee, "Org")}
            >
                {ls.map((record, index) => {
                    return (
                        <Option value={record.key}>{record.val}</Option>
                    )
                })}
            </Select>
        )
    }
    renderModules = () => {
        let ls = [];
        let org = this.state.Org;
        for (let i in this.state.Projects) {
            const row = this.state.Projects[i];

            if (row.org === org) {
                ls.push({
                    key: row.name,
                    val: row.name,
                })
            }
        }
        return (
            <Select
                name={"selectedProject"}
                defaultValue=""
                onChange={(e, ee) => this.handleChange(ee, "selectedProject")}
            >
                {ls.map((record, index) => {
                    return (
                        <Option value={record.key}>{record.val}</Option>
                    )
                })}
            </Select>
        )
    }
    handleChangeFilter = (val, key) => {
        console.log("handleChangeFilter--> ", val, key)
        let tmp = this.state;
        tmp.filters[key] = val;
        this.setState(tmp);
    }
    handleChangeFilterAddition = (val, key) => {
        console.log("handleChangeFilterAddition--> ", val, key)
        let tmp = this.state;
        tmp.filtersAdditions[key] = val;
        this.setState(tmp);
    }
    renderFilterOptions = () => {
        let options = this.getDatabaseAttributes();
        let ls = [];
        for (let i in options) {
            let row = options[i];
            if (row.datatype === "list") {
                let arr = [];// row.options.split(",");
                for (let a in row.options) {
                    arr.push(a);
                }
                ls.push(
                    <Col span={7}>
                        <Select
                            showSearch
                            style={{margin: 10, maxWidth: "100%", minWidth: "100%"}}
                            placeholder={"Select " + row.fieldname}
                            name={row.fieldname}
                            onChange={(e, ee) => this.handleChangeFilter(e, row.fieldname)}
                        >
                            {arr.map((record, index) => {
                                return (
                                    <Option value={record}>{record}</Option>
                                )
                            })}
                        </Select>
                    </Col>
                )
            }
        }

        return (
            <Card title="Filter by Options">
                <Row style={{
                    display: "flex",
                    maxWidth: "100%",
                    minWidth: "100%",
                    borderBottomWidth: 1,
                    borderColor: "black",
                }}>
                    {ls.map((row => {
                        return row
                    }))}
                    <Col span={7}>
                        <Button
                            type="dashed"
                            icon={<SearchOutlined/>}
                            onClick={this.onClickBtnFilterSearch}
                            style={{margin: 10, marginLeft: 20}}
                        >
                            Search
                        </Button>
                    </Col>
                </Row>
            </Card>
        )
    }
    renderFilter3 = () => {

        return (
            <div>

                <Search
                    placeholder="input search text"
                    allowClear
                    enterButton="Search"
                    size="large"
                    onSearch={this.onSearch}
                    style={styles.inputSearch}
                    onChange={this.onChangeSearch}
                />

            </div>
        )
    }
    renderFilter2 = () => {
        let userInfo = GetUserToken();
        let {project} = this.getInfo();
        let org = userInfo.Org;
        let state = this.state;
        let _this = this;
        const buildSelect = (arrayIn, name, label) => {
            let ls = [];
            for (let i in arrayIn) {
                const row = arrayIn[i];
                if (row.org !== org) {
                    continue
                }
                if (row.module !== project) {
                    continue
                }

                ls.push({
                    key: row.name,
                    val: <span style={{color: row.color}}>{row.name}</span>,
                })
            }
            return (
                <Col span={7}>
                    <Select
                        name={name}
                        placeholder={"Select " + name}
                        onChange={(e) => this.handleChangeFilterAddition(e, name)}
                        style={{minWidth: "100%", margin: 10}}
                    >
                        {ls.map((record) => {
                            return (
                                <Option value={record.key}>{record.val}</Option>
                            )
                        })}
                    </Select>
                </Col>
            )
        }

        return (
            <Card title="Filter by status stage and activity">
                <Row style={{
                    display: "flex",
                    maxWidth: "100%",
                    minWidth: "100%",
                    borderBottomWidth: 1,
                    borderColor: "black",
                }}>
                    {buildSelect(this.state.Statuses, "status", "Status")}
                    {buildSelect(this.state.Stages, "stages", "Stages")}
                    {buildSelect(this.state.Priorities, "priorities", "Priorities")}
                    {buildSelect(this.state.Activities, "activities", "Activities")}
                    <Col span={7}>
                        <Button
                            type="dashed"
                            icon={<SearchOutlined/>}
                            onClick={this.onClickBtnFilterAdditionalSearch}
                            style={{margin: 10, marginLeft: 20}}
                        >
                            Search
                        </Button>
                    </Col>
                </Row>
            </Card>
        )
    }
    renderButtonRequestAction = (item) => {
        let _this = this;
        /*
        showActionActivity:false,
            showActionStage:false,
            showActionActionStatus:false,
            */
        const makeButtons = () => {
            return (
                <div style={styles.makeButtons}>
                    {this.getSelectedPopoverTitle()}
                    <br/>
                    <Button type={"Dashed"} style={styles.buttonMaker}
                            onClick={() => _this.setState({showActionActivity: true, showActions: {}})}
                    >
                        Activity
                    </Button>

                    <Button type={"Dashed"} style={styles.buttonMaker}
                            onClick={() => _this.setState({showActionStage: true, showActions: {}})}
                    >
                        Stage
                    </Button>
                    <br/>
                    <Button type={"Dashed"} style={styles.buttonMaker}
                            onClick={() => _this.setState({showActionStatus: true, showActions: {}})}
                    >
                        Status
                    </Button>
                    <Button type={"Dashed"} style={styles.buttonMaker}
                            onClick={() => _this.setState({showActionPriority: true, showActions: {}})}
                    >
                        Priority
                    </Button>
                    <br/>
                    <Button type={"Dashed"} style={styles.buttonMaker}
                            onClick={() => _this.setState({showActionComment: true, showActions: {}})}
                    >
                        Comment
                    </Button>
                    <Button type={"Dashed"} style={styles.buttonMaker}
                            onClick={() => _this.setState({showActionReminder: true, showActions: {}})}
                    >
                        Reminder
                    </Button>
                    <br/>
                    <a onClick={_this.requestNewActionClose}>Close</a>
                </div>
            )
        }

        return (
            <Popover
                content={makeButtons()}
                title="New Action"
                trigger="click"
                visible={this.getVisibility(item)}
                onVisibleChange={(visible) => this.requestNewActionHandleVisibleChange(item, visible)}
            >
                <a onClick={() => this.requestNewActionOpen(item)}>
                    <PlusOutlined color={"blue"} size={56}/>
                </a>
            </Popover>
        )
    }

    render() {
        const {initLoading, loading, list} = this.state;
        const loadMore =
            !initLoading && !loading ? (
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: 12,
                        height: 32,
                        lineHeight: '32px',
                    }}
                >
                    <Button onClick={this.onLoadMore}>loading data</Button>
                </div>
            ) : null;

        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>

                    <div style={{minWidth: "100%", padding: 10}}>

                        <div style={styles.radiusMe}>

                            <PageHeader
                                info={this.getInfo()}
                                className="site-page-header"
                                onBack={() => window.history.back()}
                                title={""}
                                subTitle="Helpdesk management system"
                                extra={[
                                    <h3
                                        type="dashed"
                                        icon={<PlusOutlined/>}
                                        style={{
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            margin: 10,
                                        }}
                                        onClick={() => this.openNewCaseDrawer()}
                                    >
                                        New incident
                                    </h3>,
                                ]}
                            >
                            </PageHeader >
                            {/*<HeaderNewCase _this={this} info={this.getInfo()}/>*/}
                        </div>

                        <DrawerNewEntry
                            _this={this}
                            attributes={this.getAttributes()}
                            closeDrawer={this.closeDrawer}
                            onSubmitRecord={this.onSubmitRecord}
                            visible={this.state.showNewCase}
                            handleChangeInput={this.handleChangeInput}
                            getHandleChangeValKey={this.getHandleChangeValKey}
                            title={"CREATE NEW INCIDENT"}
                        />



                    </div>
                </div>
                <DrawerNewEntry
                    _this={this}
                    attributes={this.getAttributes()}
                    closeDrawer={this.closeDrawer}
                    onSubmitRecord={this.onSubmitRecord}
                    visible={this.state.showNewCase}
                    handleChangeInput={this.handleChangeInput}
                    getHandleChangeValKey={this.getHandleChangeValKey}
                    title={"CREATE NEW INCIDENT"}
                />
                <NewActivityDrawer _this={this}/>
                <NewStatusDrawer _this={this}/>
                <NewPriorityDrawer _this={this}/>
                <NewStageDrawer _this={this}/>
                <NewCommentDrawer _this={this}/>
                <NewReminderDrawer _this={this}/>
                <MoreDetailDrawer _this={this}/>
            </Page>
        );
    }
}

export default Connector(WorkboardActionPage);

const styles = {
    radiusMe: {
        border: "1px solid red",
        borderRadius: 5,
    },
    buttonNewCase: {
        minWidth: "18%",
        maxWidth: "18%",
        margin: 10,
    },
    inputSearch: {
        minWidth: "100%",
        maxWidth: "100%",
        margin: 10,
    },
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    },
    makeButtons: {
        /*display:"flex",
        flex:1,
        minWidth:150,
        maxWidth:150,
        justifyContent:"center"*/
    },
    buttonMaker: {
        marginTop: 10,
        minWidth: "50%",
        maxWidth: "50%",

    }
}

